import React from "react";
import PulseDesktopCarousel from "@features/pulse/components/PulseDesktopCarousel/PulseDesktopCarousel";
import { PulsePageProps } from "@features/pulse/utils/types";

export default function PulseDesktopPage({
  sortedPulseData,
  setCurrentSlide,
  currentSlide,
  setCurrentSlideId,
  backToBt = "/",
}: PulsePageProps): React.ReactElement {
  if (sortedPulseData.length === 0) return <></>;

  return (
    <div
      data-testid="pulse-desktop-page"
      className="w-svh hidden h-[calc(100svh_-_60px)] items-center justify-center overflow-x-hidden lg:flex"
    >
      <PulseDesktopCarousel
        sortedPulseData={sortedPulseData}
        currentSlide={currentSlide}
        setCurrentSlide={setCurrentSlide}
        setCurrentSlideId={setCurrentSlideId}
        backToBt={backToBt}
      />
    </div>
  );
}
